module.exports = __webpack_public_path__ + "static/media/_MIC2612.image.411a268f.png";